import { render, staticRenderFns } from "./inventoryStatistics.vue?vue&type=template&id=33d711ec&scoped=true&"
import script from "./inventoryStatistics.vue?vue&type=script&lang=js&"
export * from "./inventoryStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d711ec",
  null
  
)

export default component.exports